"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BBAuthTokenErrorCode = void 0;
var BBAuthTokenErrorCode;
(function (BBAuthTokenErrorCode) {
    BBAuthTokenErrorCode[BBAuthTokenErrorCode["Unspecified"] = 0] = "Unspecified";
    BBAuthTokenErrorCode[BBAuthTokenErrorCode["NotLoggedIn"] = 1] = "NotLoggedIn";
    BBAuthTokenErrorCode[BBAuthTokenErrorCode["InvalidEnvironment"] = 2] = "InvalidEnvironment";
    BBAuthTokenErrorCode[BBAuthTokenErrorCode["PermissionScopeNoEnvironment"] = 3] = "PermissionScopeNoEnvironment";
    BBAuthTokenErrorCode[BBAuthTokenErrorCode["Offline"] = 4] = "Offline";
})(BBAuthTokenErrorCode = exports.BBAuthTokenErrorCode || (exports.BBAuthTokenErrorCode = {}));
